import Vue from 'vue';
import Router from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch';
import {
  authGuard,
  globalGuard,
  meetAndGreetGuard,
  publicGuard,
  publicShowsGuard,
  shippingAddressGuard,
} from './middleware/guards';

Vue.use(Router);
Vue.use(RouterPrefetch);

export default function (options: { invitationQuery?: string } = {}) {
  const router = new Router({
    mode: 'history',
    routes: [
      {
        path: '/',
        redirect: '/public/login',
      },
      {
        path: '/wall',
        name: 'wall',
        component: () => import('./Block.vue'),
      },
      {
        path: '/welcome',
        name: 'welcome',
        component: () => import('./views/public/Welcome.vue'),
      },
      {
        path: '/reset',
        name: 'reset',
        component: () => import('./views/public/ResetPassword.vue'),
      },
      {
        path: '/verify',
        name: 'verify',
        redirect: '/public/login',
      },
      {
        path: '/auth',
        redirect: '/auth/panorama',
        component: () => import('./layouts/Auth.vue'),
        beforeEnter: authGuard,
        children: [
          {
            path: 'panorama',
            name: 'panorama',
            component: () => import('./views/auth/CityPanorama.vue'),
          },
          {
            path: 'news',
            name: 'news',
            component: () => import('./views/auth/News.vue'),
          },
          {
            path: 'bank',
            name: 'bank',
            component: () => import('./views/auth/Bank.vue'),
          },
          {
            path: 'sage',
            name: 'sage',
            component: () => import('./views/auth/Sage.vue'),
          },
          {
            path: 'merchant',
            name: 'merchant',
            component: () => import('./views/auth/Shop.vue'),
          },
          {
            path: 'ministry',
            name: 'ministry',
            component: () => import('./views/auth/Ministry.vue'),
          },
          {
            path: 'cinema',
            name: 'cinema',
            component: () => import('./views/auth/Cinema.vue'),
          },
          {
            path: 'studio',
            name: 'studio',
            component: () => import('./views/auth/Studio.vue'),
          },
          {
            path: 'arena',
            name: 'arena',
            component: () => import('./views/auth/Arena.vue'),
          },
          {
            path: 'meet-and-greet',
            name: 'meet-and-greet',
            component: () => import('./views/auth/MeetAndGreet.vue'),
            beforeEnter: meetAndGreetGuard,
          },
          {
            path: 'shipping-address',
            name: 'shipping-address',
            component: () => import('./views/auth/ShippingAddress.vue'),
            beforeEnter: shippingAddressGuard,
          },
        ],
      },
      {
        path: '/public',
        redirect: '/public/login',
        beforeEnter: publicGuard,
        component: () => import('./layouts/Public.vue'),
        children: [
          {
            path: 'register',
            name: 'register',
            component: () => import('./views/public/Register.vue'),
          },
          {
            path: 'login',
            name: 'login',
            component: () => import('./views/public/CityGates.vue'),
          },
        ],
      },
      {
        path: '/shows',
        beforeEnter: publicShowsGuard,
        component: () => import('./layouts/Shows.vue'),
        children: [
          {
            path: '/',
            name: 'shows',
            component: () => import('./views/shows/Shows.vue'),
          },
          {
            path: 'ticket',
            name: 'ticket',
            component: () => import('./views/shows/Ticket.vue'),
            beforeEnter: (to, from, next) => {
              if (to.query.token) {
                next();
              } else {
                next({ name: 'shows' });
              }
            },
          },
          {
            path: ':id',
            name: 'show',
            component: () => import('./views/shows/Show.vue'),
          },
        ],
      },
      {
        path: '/terms',
        component: () => import('./layouts/Plain.vue'),
        children: [
          {
            path: '/',
            name: 'terms',
            component: () => import('./Terms.vue'),
          },
          {
            path: 'secret-gathering',
            name: 'secret-gathering-terms',
            component: () => import('./SecretGatheringTerms.vue'),
          },
        ],
      },
      {
        path: '/privacy',
        component: () => import('./layouts/Plain.vue'),
        children: [
          {
            path: '/',
            name: 'privacy',
            component: () => import('./Privacy.vue'),
          },
        ],
      },
    ],
  });
  router.onError((error) => {
    if (/loading chunk.* failed./i.test(error.message && error.message.toLowerCase())) {
      window.location.reload();
    }
  });
  router.beforeEach(globalGuard(options.invitationQuery));
  return router;
}
